import React, { useEffect, useState } from "react"
import { Table, Row, Col, Modal, Form, Label } from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Select from "react-select"
// common
import Pagination from "components/Common/Pagination"
import {
  fetchNodeData,
  FetchNodeDeleteData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import { colourStyles } from "utils/common-options"
import NewPagination from "components/Common/Newpagination"

function TableContainer({
  columns,
  data,
  Duration,
  Months,
  setLoading,
  getData,
}) {
  const [status, setStatus] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)
  const [duration, setDuration] = useState(null)
  const [monthDuration, setMonths] = useState("Months")

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  const navigate = useNavigate()

  const addRenewalDuration = async e => {
    e.preventDefault()

    // Validation
    if (!duration || !monthDuration) {
      Swal.fire({ icon: "warning", text: "Please fill all required fields" })
      return // Stop further execution
    }

    // Call API only if validation passes
    const response = await FetchNodePostData(
      setLoading,
      "hostingRenewalDuration/renewal/add",
      secureLocalStorage.getItem("auth_token"),
      {
        duration,
        month_duration: monthDuration,
      }
    )

    if (response?.data?.success) {
      Swal.fire({ icon: "success", text: "Updated Successfully" })
      setStatus(false)
      setDuration("")
      setMonths("")
      getData()
    } else {
      Swal.fire({ icon: "error", text: response?.data?.message || "Failed" })
    }
  }

  return (
    <div className="px-2">
      <div
        className={`flex-column fixed-buttons ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <button
          onClick={() => {
            setStatus(true)
          }}
          className="btn btn-purple border-radius fix-btn"
        >
          <i className="fas fa-plus me-2"></i>
          <span>Renewal</span>
        </button>
        <a
          onClick={() => navigate(-1)}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </a>
      </div>

      <Row className="mb-2">
        <Col lg={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <a
              className="border-radius btn btn-purple"
              onClick={() => {
                setStatus(true)
              }}
            >
              <i className="fas fa-plus me-2 icon-size"></i>Add Renewal Duration
            </a>
            <a
              className="border-radius btn text-white ms-md-2 btn-red"
              onClick={() => navigate(-1)}
            >
              <i className="dripicons-cross me-2 icon-center"></i>Cancel
            </a>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead className={`${fixedContent ? "fixed-setting-header" : ""}`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`col-md-${index === 0 ? "1" : index === 1 ? "9" : "2"
                    } ${column.className}`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      key={index}
                      className={`col-md-${index === 0 ? "1" : index === 1 ? "9" : "2"
                        }`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
          nextPage={nextPage}
        />
      </Row>

      <Modal
        isOpen={status}
        size="sm"
        className="bd-custom-md-2"
        centered
        onSubmit={addRenewalDuration}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Add Renewal Duration</h5>
          <button
            type="button"
            onClick={() => {
              setStatus(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form className="row">
            <div className="mb-3 col-md-6">
              <Label htmlFor="formrow-firstname-Input">
                Duration<span className="text-danger"> *</span>
              </Label>
              <Select
                placeholder="Select duration"
                className="basic-multi-select border-radius"
                classNamePrefix="select"
                styles={colourStyles}
                options={Duration}
                required
                onChange={data => setDuration(data.value)}
              />
            </div>
            <div className="mb-3 col-md-6">
              <Label htmlFor="formrow-firstname-Input">
                Months duration<span className="text-danger"> *</span>
              </Label>
              <Select
                placeholder="Select Time"
                className="basic-multi-select border-radius"
                classNamePrefix="select"
                styles={colourStyles}
                required
                options={Months}
                onChange={data => setMonths(data.label)}
              />
            </div>

            <div className="mt-20">
              <button className="border-radius btn btn-purple">Submit</button>
            </div>
          </Form>
        </div>
      </Modal>
    </div>
  )
}

const RenewalDuration = () => {
  const [editStatus, setEditStatus] = useState(false)
  const [duration, setDuration] = useState("")
  const [monthDuration, setMonthDuration] = useState("")
  const [editId, setEditId] = useState(null)

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        className: "id-width",
      },
      {
        Header: "Renewal Duration",
        accessor: row => `${row.duration} ${row.month_duration}`,
        Cell: cellProps => {
          return (
            <div>
              {cellProps?.row?.original?.duration}
              {` `}
              {cellProps?.row?.original?.month_duration}
            </div>
          )
        },
      },
      {
        Header: "Action",
        accessor: "action",
        className: "action-width",
        Cell: cellProps => {
          return (
            <div>
              <a
                onClick={() => {
                  setEditId(cellProps?.row?.original.id)
                  setDuration(cellProps?.row?.original.duration)
                  setMonthDuration(cellProps?.row?.original.month_duration)
                  setEditStatus(true)
                }}
                className="btn btn-sm me-1 btn-outline-secondary"
              >
                <i className="fas fa-pencil-alt"></i>
              </a>
              <a
                onClick={() => {
                  deleteRenewal(cellProps?.row?.original?.id)
                }}
                className="btn btn-sm btn-danger"
              >
                <i className="fas fa-trash-alt"></i>
              </a>
            </div>
          )
        },
      },
    ],
    []
  )

  const getData = async () => {
    const response = await fetchNodeData(
      setLoading,
      "hostingRenewalDuration/renewal/get",
      secureLocalStorage?.getItem("auth_token")
    )
    setData(response.data)
  }

  useEffect(() => {
    getData()
  }, [])

  const StaticData = [
    {
      id: 1,
      name: "7 Month",
    },
    {
      id: 2,
      name: "1 Month",
    },
    {
      id: 3,
      name: "8 Month",
    },
    {
      id: 4,
      name: "10 Month",
    },
    {
      id: 5,
      name: "3 Month",
    },
    {
      id: 3,
      name: "8 Month",
    },
    {
      id: 4,
      name: "10 Month",
    },
    {
      id: 5,
      name: "3 Month",
    },
  ]

  const Duration = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
  ]
  const Months = [
    { label: "Month", value: "1" },
    { label: "Year", value: "2" },
  ]

  const editRenewal = async e => {
    e.preventDefault()

    const response = await FetchNodePutData(
      setLoading,
      "hostingRenewalDuration/renewal/edit",
      editId,
      {
        duration,
        month_duration: monthDuration,
      }
    )

    if (response?.data?.success) {
      Swal.fire({ icon: "success", text: "Updated Successfully" })
      setEditStatus(false)
      setDuration("")
      setMonthDuration("")
      setEditId(null)
      getData()
    } else {
      Swal.fire({ icon: "error", text: response?.data?.message || "Failed" })
    }
  }

  const deleteRenewal = async id => {
    Swal.fire({
      icon: "warning",
      text: "Are you sure to delete this renewal duration?",
      showCancelButton: true,
    }).then(async result => {
      if (result.isConfirmed) {
        const response = await FetchNodeDeleteData(
          setLoading,
          "hostingRenewalDuration/renewal/delete",
          id
        )
        if (response?.data?.success) {
          Swal.fire({ icon: "success", text: "Deleted" })
          getData()
        } else {
          Swal.fire({ icon: "error", text: "Delete failed" })
        }
      }
    })
  }

  return (
    <div>
      {loading && <Loader />}
      <Row>
        <Col lg={12} className="p-0">
          <div className="responsive-table">
            <TableContainer
              columns={columns}
              data={data || StaticData}
              Duration={Duration}
              Months={Months}
              setLoading={setLoading}
              getData={getData}
            />
          </div>
        </Col>

        <Modal
          isOpen={editStatus}
          size="sm"
          className="bd-custom-md-2"
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title">Edit Renewal Duration</h5>
            <button
              type="button"
              onClick={() => setEditStatus(false)}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
          <div className="modal-body">
            <Form className="row" onSubmit={editRenewal}>
              <div className="mb-3 col-md-6">
                <Label>Duration</Label>
                <Select
                  placeholder="Select"
                  styles={colourStyles}
                  className="basic-multi-select border-radius"
                  classNamePrefix="select"
                  options={Duration}
                  value={Duration.find(d => d.label == duration) || null}
                  onChange={opt => setDuration(opt.label)}
                />
              </div>
              <div className="mb-3 col-md-6">
                <Label>Months duration</Label>
                <Select
                  placeholder="Select"
                  styles={colourStyles}
                  className="basic-multi-select border-radius"
                  classNamePrefix="select"
                  options={Months}
                  value={Months.find(m => m.label === monthDuration) || null}
                  onChange={opt => setMonthDuration(opt.label)}
                />
              </div>
              <div className="mt-20">
                <button type="submit" className="border-radius btn btn-purple">
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>
      </Row>
    </div>
  )
}

export default RenewalDuration
